class Menu {
  constructor(settings) {
    this.settings = settings;
    this.menuElement = document.querySelector(this.settings.selectors.menuList);
    this.buttonElement = document.querySelector(this.settings.selectors.button);
    this.isVisible = false;
    this.mobileQuery = this.settings.mobileQuery;

    if (!this.menuElement || !this.buttonElement || !this.mobileQuery) return;

    this.setListeners();
  }

  // Sets up event listeners for responsive behavior and button interaction
  setListeners() {
    // Recalculate init class on screen resize
    this.mobileQuery.addEventListener("change", () => {
      this.applyInitState();
      if (this.isVisible) {
        this.toggleVisibility(false);
      }
    });

    // Initial check on page load
    window.addEventListener("load", () => {
      this.applyInitState();
    });

    // Toggle menu when button is clicked
    this.buttonElement.addEventListener("click", () => {
      this.toggleVisibility();
    });
  }

  // Adds or removes the init class based on media query match
  applyInitState() {
    this.menuElement.classList.toggle(
      this.settings.classNames.init,
      this.mobileQuery.matches
    );
  }

  // Toggles menu visibility and updates related classes
  toggleVisibility(state) {
    const isCurrentlyOpen = this.menuElement.classList.contains(this.settings.classNames.open);
    this.isVisible = state !== undefined ? state : !isCurrentlyOpen;

    this.menuElement.classList.toggle(this.settings.classNames.open, this.isVisible);
    this.buttonElement.classList.toggle(this.settings.classNames.buttonActive, this.isVisible);
  }
}

export default Menu;
